/* eslint-disable no-console */
import { Logger, pino } from 'pino';
import { CustomLevels, CustomLevelsType } from './shared';

const overrideDefaultOutput = false;

let instance = pino<keyof CustomLevelsType>({
  customLevels: CustomLevels,
  browser: { asObject: true },
  level: process.env.NEXT_PUBLIC_BANZAI_LOG_LEVEL || 'info',
});

if (overrideDefaultOutput) {
  console.log = (...args) => instance.info.call(instance, ...args);
  console.info = (...args) => instance.info.call(instance, ...args);
  console.warn = (...args) => instance.warn.call(instance, ...args);
  console.error = (...args) => instance.error.call(instance, ...args);
  console.debug = (...args) => instance.debug.call(instance, ...args);
}

export function logger(): Logger<keyof CustomLevelsType> {
  return instance;
}

export function setInstance(newInstance: Logger<keyof CustomLevelsType>) {
  instance = newInstance;
}
